import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import ListNameLabel from 'flow-doctor-lib/components/common/ListNameLabel';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import { jsx as _jsx } from "react/jsx-runtime";
const EventEnrollListTriggerAnalysisReason = ({
  diagnosisReason,
  selectedEnrollment
}) => {
  return /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: diagnosisReason.changeStatus === 'ADDED' ? 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeReason.description.EVENT_ENROLL_LIST_TRIGGER.added_jsx' : 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeReason.description.EVENT_ENROLL_LIST_TRIGGER.removed_jsx',
      elements: {
        ListNameLabel,
        b: 'b'
      },
      options: {
        portalId: selectedEnrollment.portalId,
        listId: diagnosisReason.listId,
        showId: getIsInternal()
      }
    })
  });
};
export default EventEnrollListTriggerAnalysisReason;